import { Component, Input, OnChanges } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { CarDetailEquipmentListComponent } from './car-detail-equipment-list/car-detail-equipment-list.component';
import { BoxSectionComponent } from '@atoms/box-section/box-section.component';
import { TabNavComponent } from '@molecules/tab-nav/tab-nav.component';
import { TabNavItemComponent } from '@molecules/tab-nav/tab-nav-item/tab-nav-item.component';
import { TabNavSwiperComponent } from '@molecules/tab-nav-swiper/tab-nav-swiper.component';
import { CarEquipmentFinal } from '@models/car.model';

@Component({
  selector: 'app-car-detail-equipment',
  imports: [TranslateModule, CarDetailEquipmentListComponent, BoxSectionComponent, TabNavComponent, TabNavItemComponent, TabNavSwiperComponent],
  templateUrl: './car-detail-equipment.component.html',
  styleUrl: './car-detail-equipment.component.scss',
})
export class CarDetailEquipmentComponent implements OnChanges {
  @Input() equipment?: CarEquipmentFinal;
  public active?: string;

  ngOnChanges(): void {
    if (!this.equipment) return;
    const categories = ['interior', 'exterior', 'technology'];
    for (const category of categories) {
      if (this.equipment[category as keyof CarEquipmentFinal]?.items.length) {
        this.active = category;
        break;
      }
    }
  }
}
